import React from 'react'
import translatePath from './translatePath'

export const defaultX = 0
export const defaultY = 0
export const width = 550
export const height = 1150

export const path = [
  'M475,0 C516.007143,0 549.327643,32.9104288 549.989952,73.7597379 L550,75 L550,875 C550,1026.87831 426.878306,1150 275,1150 C124.640477,1150 2.46530954,1029.32843 0.0368421431,879.547628 L0,875 L0,275 C0,123.121694 123.121694,0 275,0 C324.462948,0 370.875851,13.0587943 410.979111,35.9167848 C424.149754,14.3775975 447.895843,0 475,0 Z',
  'M275,150 C206.654762,150 151.120595,204.850715 150.016746,272.932896 L150,275 L150,875 C150,944.035594 205.964406,1000 275,1000 C343.345238,1000 398.879405,945.149285 399.983254,877.067104 L400,875 L400,275 C400,205.964406 344.035594,150 275,150 Z',
  'M275,200 C316.421356,200 350,233.578644 350,275 L350,875 C350,916.421356 316.421356,950 275,950 C233.578644,950 200,916.421356 200,875 L200,275 C200,233.578644 233.578644,200 275,200 Z'
]

export const getPath = (x, y) => translatePath(path, defaultX, defaultY, x, y)

const D = () => (
  <symbol id="d" viewBox={`${defaultX} ${defaultY} ${width} ${height}`}>
    <path d={path.join(' ')} />
  </symbol>
)

export default D
